export default __webpack_public_path__ + "static/media/09_photo.a0a322e1.jpeg";